<template>
  <div>
    <v-btn
      v-if="!is_file(src)"
      v-bind="$attrs"
      v-on="$listeners"
      :icon="!check_text"
      :text="check_text"
      color="#000"
      :href="src"
      download
      target="_blank"
    >
      <v-icon>
        mdi-tray-arrow-down
      </v-icon>
      <span
        v-if="check_text"
        class="ml-2"
      >
        <slot name="text" />
      </span>
    </v-btn>
    <v-btn
      v-else
      v-bind="$attrs"
      v-on="$listeners"
      :icon="!check_text"
      :text="check_text"
      color="#000"
      @click="download_file"
    >
      <v-icon>
        mdi-tray-arrow-down
      </v-icon>
      <span
        v-if="check_text"
        class="ml-2"
      >
        <slot name="text" />
      </span>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { is_file } from '@/utils';

@Component
export default class DownloadBtn extends Vue {
  @Prop({
    type: [
      String,
      File,
    ],
    default: '',
  })
  src!: string | File;

  is_file = is_file;

  get check_text() {
    return 'text' in this.$scopedSlots;
  }

  download_file() {
    if (this.is_file(this.src) && typeof this.src !== 'string') {
      const link = document.createElement('a');
      const { name } = this.src;

      link.href = window.URL.createObjectURL(this.src);
      link.setAttribute('download', `${name}`);
      document.body.appendChild(link);
      link.click();
    }
  }
}
</script>
